export default "__VITE_ASSET__B58x$JeX__"